import { NewsListScreen } from '../features/news/NewsListScreen'
import { env } from '../config/env'
import { NotFoundPage } from './NotFoundPage'

/** Флаг `VITE_FEATURE_NEWS` выключен — раздела нет, адрес ведёт в «не найдено». */
export function NewsListPage() {
  return env.features.news ? <NewsListScreen /> : <NotFoundPage />
}
